import dynamic from 'next/dynamic';

import { Link } from '@natu/next-link';

import {
  BlokItem,
  DynamicRender,
  SBProps,
  StoryblokAsset,
  StoryblokLink,
  getAssetFromStoryblok,
  getLinkPropsFromStoryblok,
  sbEditable,
} from '../../../../utils';

const ResponsiveImage = dynamic(() =>
  import('@natu/ui/ResponsiveImage').then(mod => mod.ResponsiveImage),
);

const Button = dynamic(() => import('@natu/ui/Button').then(mod => mod.Button));

const DynamicIcon = dynamic(() => import('@natu/ui/DynamicIcon').then(mod => mod.DynamicIcon));

interface SBMegaMenuListProps {
  body?: BlokItem[];
  title?: string;
  link?: StoryblokLink;
  icon?: StoryblokAsset;
}

export const SBMegaMenuList = ({ blok }: SBProps<SBMegaMenuListProps>) => {
  const { body, title, icon, link } = blok;

  const resolvedLink = getLinkPropsFromStoryblok(link);
  const iconProps = getAssetFromStoryblok(icon, { type: 'image' });

  return (
    <div className="flex flex-col gap-x-4" {...sbEditable(blok)}>
      <div className="flex items-center gap-4">
        {iconProps?.src && (
          <ResponsiveImage width={40} height={40} className="h-10 w-10" {...iconProps} />
        )}
        {resolvedLink.href ? (
          <Button variant="link-gray" size="link" asChild>
            <Link className="flex items-center gap-x-2 text-lg xl:text-base" {...resolvedLink}>
              {title} <DynamicIcon icon="arrowRight" />
            </Link>
          </Button>
        ) : (
          <p className="text-lg font-semibold text-gray-600 xl:text-base">{title}</p>
        )}
      </div>
      <ul className="ml-14 mt-4 flex flex-col gap-4">
        <DynamicRender asListItem data={body} />
      </ul>
    </div>
  );
};
